class PurchaseOrderNoteService {
  #cashQoreAxiosInstance;

  constructor(cashQoreAxiosInstance) {
    if (!cashQoreAxiosInstance) {
      throw new Error('Axios instance is required');
    }
    this.#cashQoreAxiosInstance = cashQoreAxiosInstance;
  }

  /**
   * Create a PurchaseOrderNote
   * @param {number} poNumber
   * @param {number} dispatchId
   * @param {number} purchaseOrderNoteTypeId
   * @param {string} noteText
   * @param {string} createdBy
   * 
   * @returns {Promise<{status: number, data: {PurchaseOrderNoteId: string, PoNumber: string, DispatchId: string, PurchaseOrderNoteTypeId: number, NoteTypeName: string, DateCreated: Date, CreatedBy: string}}>>}
   */
  createPurchaseOrderNote(
    poNumber,
    dispatchId,
    purchaseOrderNoteTypeId,
    noteText,
    createdBy,
  ) {
    return this.#cashQoreAxiosInstance.post('/createPurchaseOrderNote', {
      poNumber: Number(poNumber),
      dispatchId: Number(dispatchId),
      purchaseOrderNoteTypeId: Number(purchaseOrderNoteTypeId),
      noteText: noteText,
      createdBy,
    });
  }

  /**
   * Retrieves PurchaseOrderNotes from the Cash Qore API.
   * @param {number} dispatchId
   * 
   * @returns {Promise<{PurchaseOrderNoteId: string, PoNumber: string, DispatchId: string, PurchaseOrderNoteTypeId: number, NoteTypeName: string, DateCreated: Date, CreatedBy: string}[]}>>}
   */
  fetchPurchaseOrderNotes(dispatchId) {
    return this.#cashQoreAxiosInstance.get(`/getPurchaseOrderNotesByDispatchId?dispatchId=${dispatchId}`);
  }
}

export default PurchaseOrderNoteService;
